// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__395YP","sectionsWrapper":"style_sectionsWrapper__1oO0C"};